import React from 'react';
import '../styles/bannermsg.css';

const ContactHome = () => {
    return (
        <div className="contact-home">
            <div className="contact-home-content">
                <h1 className="contact-home-title">
                    Synectiks - Simplicity, Confidence, and Innovation for the Modern Businesses.
                </h1>
                {/* <button className="contact-home-btn">
                    Contact Us
                </button> */}
            </div>
        </div>
    );
};

export default ContactHome;